import { TextField } from '@mui/material'
import React from 'react'
import { useRecoilValue } from 'recoil';
import useSavePatient from 'src/Patient/hooks/useSavePatient';
import { errorsFormRegisterState, valuesFormRegisterState } from 'src/Patient/state/atoms';
import InputLabelCustom from 'src/shared/components/forms/InputLabelCustom'

const LastnamePatField = () => {
    const { handleChange } = useSavePatient();
    const { uswApePat } = useRecoilValue(valuesFormRegisterState);
    const { uswApePat: errorUswApePat } = useRecoilValue(errorsFormRegisterState);

    return (
        <>
            <InputLabelCustom htmlFor="input-apepat" text="Apellido paterno (*)" />
            <TextField
                id="input-apepat"
                size="small"
                error={errorUswApePat && errorUswApePat.length > 0 ? true : false}
                helperText={errorUswApePat && errorUswApePat.length > 0 ? `${errorUswApePat.join("\n")}` : ''}
                style={{ width: '100%' }}
                name="uswApePat"
                type="text"
                value={uswApePat || ""}
                InputLabelProps={{
                    shrink: true,
                }}
                variant="outlined"
                onChange={handleChange}
                autoComplete="off"
                placeholder='Ej: Cifuentes'
            />
        </>
    )
}

export default LastnamePatField
